import { Department } from '@apps/its2/domain/models/department';
import { StatusesMetadata } from '@common/models';

export const BackItsmFeatureKey = 'itsm';

export interface IBackItsmState extends StatusesMetadata
{
    subEntities: string[];
    selectedDepartment: Department;
}

export const BackItsmInitialState: IBackItsmState = {
    subEntities: [],
    isLoading: false,
    isLoaded: false,
    isEmpty: false,
    isOups: false,
    selectedDepartment: null,
    expirationDate: null
};
